import styles from "assets/jss/styles";

const langSelectorStyle = (theme) => {
  const { defaultFont } = styles(theme);

  return {
    langSelectorContainer: {
      ...theme.palette.sideMenu,
      width: "100%",
    },
    langSelector: {
      color: "inherit",
      width: "100%",
      "&:before,&:after": {
        display: "none !important",
      },
    },
    langSelectorText: {
      ...defaultFont,
      margin: "0",
      position: "relative",
      transform: "translateX(0px)",
      color: "inherit",
      opacity: "1",
      whiteSpace: "nowrap",
      display: "inline-block",
      transition: "transform 300ms ease 0s, opacity 300ms ease 0s",
      fontSize: "15px",
      paddingLeft: "15px",
    },
    langSelectMenu: {
      textOverflow: "unset",
      paddingTop: 0,
    },
  };
};
export default langSelectorStyle;
